import { createContext } from 'react';

import type { ToastContainer } from '@cognite/cogs-lab-v11';
import type { ConfigProvider } from '@cognite/cogs.js-v11';
import type { SDKProvider } from '@cognite/sdk-provider';

import type { AtlasHomeOptInProvider } from '../pages/landing-page/hooks/use-has-user-enabled-atlas-home';

import type { CdmAccessProvider } from './access-provider/cdm-access-provider';
import type { CdmAppConfigFiltersProvider } from './app-config-filters-provider/cdm-app-config-filters-provider';
import type { BackButtonUrlProvider } from './back-button-url-provider/back-button-url-provider';
import type { CdmCurrentUserProvider } from './current-user-provider/cdm-current-user-provider';
import type { CdmFDMServicesProvider } from './fdm-services/cdm-fdm-services-provider';
import type { CdmAppConfigProvider } from './is-idm-provider/cdm-app-config-provider';
import type { NetworkStatusProvider } from './network-status-provider/network-status-provider';
import type { PersistQueryFunctionsProvider } from './persist-query-functions-provider/persist-query-functions-provider';
import type { CdmSelectedLocationProvider } from './selected-location-provider/cdm-selected-location-provider';
import type { CdmUserOnboardingProvider } from './user-onboarding-provider/cdm-user-onboarding-provider';

export interface CdmProvidersContextInterface {
  CdmAppConfigProvider: typeof CdmAppConfigProvider;
  ConfigProvider: typeof ConfigProvider;
  ToastContainer: typeof ToastContainer;
  CdmFDMServicesProvider: typeof CdmFDMServicesProvider;
  BackButtonUrlProvider: typeof BackButtonUrlProvider;
  NetworkStatusProvider: typeof NetworkStatusProvider;
  CdmCurrentUserProvider: typeof CdmCurrentUserProvider;
  CdmSelectedLocationProvider: typeof CdmSelectedLocationProvider;
  CdmUserOnboardingProvider: typeof CdmUserOnboardingProvider;
  CdmAppConfigFiltersProvider: typeof CdmAppConfigFiltersProvider;
  PersistQueryFunctionsProvider: typeof PersistQueryFunctionsProvider;
  SDKProvider: typeof SDKProvider;
  CdmAccessProvider: typeof CdmAccessProvider;
  AtlasHomeOptInProvider: typeof AtlasHomeOptInProvider;
}

export const CdmProvidersContext =
  createContext<CdmProvidersContextInterface | null>(null);
